/**
 * Map message ("plant a flag") constants.
 *
 * Each player can have ONE message planted on the map at a time — placing a
 * new one moves/replaces it. Placement costs coins (soft-currency sink);
 * removal is free. Enforced server-side in the placeMessage Cloud Function.
 */

/** Maximum message length after trimming */
export const MESSAGE_MAX_LENGTH = 40;

/** Coin cost to place or move a message */
export const MESSAGE_COST_COINS = 20;

/** Zoom level at or above which messages render on the map */
export const MESSAGE_MIN_ZOOM = 12;
